function notEmptyNode(value) {
  return value !== null && value !== undefined;
}
export default notEmptyNode;